__webpack_require__.p = "/bizx-smart/osaka-agro/";